import { PageHeader, PageBody } from "@/components/AppShell";
import { useAuth } from "@/context/AuthContext";
import { TerrainJourTab } from "@/pages/AdminPointage";

// Page DÉDIÉE « Terrain du jour » — visibilité « qui est où » en un coup d'œil.
// Ouverte à la chargée des opérations (rôle « lecture_seule ») en LECTURE SEULE :
// elle peut appeler les collaborateurs (lien tel:) mais ne peut pas éditer les numéros.
export default function TerrainDuJour() {
  const { user } = useAuth();
  const readOnly = user?.role !== "admin";
  return (
    <div data-testid="terrain-du-jour-page">
      <PageHeader
        title="Terrain du jour"
        subtitle="Qui est prévu et présent aujourd'hui, en un coup d'œil — appelez les collaborateurs concernés." />
      <PageBody>
        <TerrainJourTab readOnly={readOnly} />
      </PageBody>
    </div>
  );
}
